import React from 'react';
import {
    LinkName,
    QuickHeaderButton,
} from 'src/domains/layouts/webview/modules/layoutSkeleton/Header/quickHeader/QuickHeader.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { observer } from 'src/utils/mobx-react';
import { Amount } from 'src_common/common/amount/Amount';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';
import { action, makeObservable } from 'mobx';
import { Common, useCommon } from 'src/domains/common/Common';
import { LocalStorageState } from 'src/domains/layouts/state/localStorage/LocalStorageState';
import { QuickHeaderLogInIcon } from './LoginIcons';
import { SdkCustomer } from 'src/domains/layouts/state/customer';
import { GoogleTagManagerState } from 'src/domains/layouts/state/googleState/GoogleTagManagerState';
import { UsersState } from 'src/domains/players/state/UsersState';

class State {
    public constructor(private readonly common: Common) {
        makeObservable(this);
    }

    @action public handleClick = (): void => {
        const gtm = GoogleTagManagerState.get(this.common);
        const starRouter = StarRouter.get(this.common);
        gtm.routingAccountChange('account-summary');
        starRouter.redirectToAccountSummary();
    };
}

export const LoginButton = observer('LoginButton', () => {
    const common = useCommon();
    const starRouter = StarRouter.get(common);
    const sdkCustomer = SdkCustomer.get(common);
    const localStorageState = LocalStorageState.get(common);
    const userState = UsersState.get(common);

    const [state] = React.useState(() => new State(common));
    const isUserAuthorized = sdkCustomer.session.isAuthorized;

    const linkParam = isUserAuthorized ? { account: 'summary' } : { account: 'login' };

    const showBalanceInHeader = localStorageState.balanceInHeader.getValue();

    const playableBalanceNow = userState.walletData.valueReady?.playableBalance;
    const playableBalance = playableBalanceNow === undefined ? new Amount('0') : new Amount(playableBalanceNow);
    const balance = sdkCustomer.money(playableBalance);

    const showHeader = isUserAuthorized ? (
        showBalanceInHeader ? (
            <span>{balance}</span>
        ) : (
            <I18n
                langKey='quick-header.account.label'
                defaultText='Account'
            />
        )
    ) : (
        <I18n
            langKey='quick-header.log-in.label'
            defaultText='Log In'
        />
    );

    const active = starRouter.accountParam;
    const activeLink = linkParam.account === active;

    const handleClick = isUserAuthorized ? state.handleClick : starRouter.redirectToLogin;
    const dataTest = isUserAuthorized ? 'account-navigation-login-link-authorized' : 'account-navigation-login-link';

    return (
        <QuickHeaderButton
            data-test={dataTest}
            isActive={activeLink}
            onClick={handleClick}
        >
            <QuickHeaderLogInIcon />
            <LinkName>{showHeader}</LinkName>
        </QuickHeaderButton>
    );
});
